<template>
<div>
    <v-text-field type="number" v-model="id" outlined background-color="white" class='mt-3'>
        <label slot="label">
            <span style="color:red; font-weight:bold;" v-if="allow===false">EXISTS</span>
            <span v-else>NEW QID</span>
        </label>
    </v-text-field>
    <div v-if="affected.prompts && affected.prompts.length>0" 
        style="border: 1px solid lightgrey; border-radius: 15px; padding: 15px; background-color: white;">
        <span style="color: red;">Affected prompts:</span>
        <ul>
            <li v-for="(item, index) in affected.prompts" :key="'affected_prompts_'+index">
                PROMPT: {{item.question}} --> RULE: {{item.rule}} --> CONDITION: {{item.condition}}
            </li>
        </ul>
    </div>
    <div v-if="affected.questions && affected.questions.length>0"
        style="border: 1px solid lightgrey; border-radius: 15px; padding: 15px; background-color: white;">
        <span style="color: red;">Affects Hidden Questions:</span>
        <ul>
            <li v-for="(item, index) in affected.questions" :key="'affected_questions_'+index">
                QUESTION: {{item.question}} --> CONDTION: {{item.condition}}
            </li>
        </ul>
    </div>
    <div v-if="affected.widgets && affected.widgets.length>0"
        style="border: 1px solid lightgrey; border-radius: 15px; padding: 15px; background-color: white;">
        <span style="color: red;">Affected widgets:</span>
        <ul>
            <li v-for="(item, index) in affected.widgets" :key="'affected_widgets_'+index">
                WIDGET: {{item.question}} --> RULE: {{item.rule}} --> CONDITION: {{item.condition}}
            </li>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        },
        questionMap: {
            type: Object,
            required: true
        },
        rules: {
            type: Object,
            required: true
        },
        widgets: {
            type: Array,
            required: true
        },
        prompts: {
            type: Array,
            required: true
        }
    },
    created: function(){
        this.init();
    },
    data: function(){
        return {
            id: null,
            allow: null,
            affected: {
                questions: null,
                widgets: null,
                prompts: null
            }
        }
    },
    methods: {
        init: function(){
            var question = this.unlink(this.question);
            this.id = question.config.id;
            this.affected.questions = this.affects_hidden(this.question.config.id);
            this.affected.widgets = this.affects_widgets(this.question.config.id);
            this.affected.prompts = this.affects_prompts(this.question.config.id);
        },
        affects_hidden: function(before){
            var questionMap = this.questionMap;
            var rules = this.rules;
            var affected = [];
            var pass = true;
            for(let qid in rules.display){
                var question = questionMap[qid];
                var ruleSet = rules.display[qid];
                for(let r=0; r<ruleSet.length; r++){
                    var rule = ruleSet[r];
                    var conditions = ruleSet[r];
                    for(let i=0; i<conditions.length; i++){
                        var condition = conditions[i];
                        if(condition.ref_id==before){
                            pass = false;
                            affected.push({
                                question: qid,
                                condition: condition.name
                            });
                        }
                    }
                }
            }
            
            return affected;
        },
        affects_widgets: function(before){
            var questionMap = this.questionMap;
            var widgets = this.widgets;
            var affected = [];
            var pass = true;
            for(let w in widgets){
                var widget = widgets[w];
                var rules = widget.rules;
                for(let r=0; r<rules.length; r++){
                    var rule = rules[r];
                    for(let c=0; c<rule.conditions.length; c++){
                        var condition = rule.conditions[c];
                        if(condition.ref_id==before){
                            pass = false;
                            affected.push({
                                widget: widget.name,
                                rule: rule.name,
                                condition: condition.name
                            })
                        }
                    }
                }
            }
            
            return affected;
        },
        affects_prompts: function(before){
            var questionMap = this.questionMap;
            var prompts = this.prompts;
            var affected = [];
            var pass = true;
            for(let w in prompts){
                var prompt = prompts[w];
                var rules = prompt.rules;
                for(let r=0; r<rules.length; r++){
                    var rule = rules[r];
                    for(let c=0; c<rule.conditions.length; c++){
                        var condition = rule.conditions[c];
                        if(condition.ref_id==before){
                            pass = false;
                            affected.push({
                                prompt: prompt.name,
                                rule: rule.name,
                                condition: condition.name
                            })
                        }
                    }
                }
            }
            
            return affected;
        }
    },
    watch: {
        id: function(after, before){
            this.allow = after==this.question.config.id ? true : false;
            if(after!=null && after.length>0 && (after!=0 && after!=this.question.config.id)){
                var q_before = this.questionMap[before];
                var q_after = this.questionMap[after];
                this.allow = (typeof q_after=='undefined') || (JSON.stringify(q_before) == JSON.stringify(q_after))
            }
            if(this.allow){
                this.$emit('update',{
                    current_qid: this.question.config.id,
                    new_qid: parseInt(this.id,10)
                });
            }
     
        },
        question: {
            deep: true,
            handler: function(){
                this.init();
            }
        }
    }
}
</script>

<style>
</style>